import Papa from 'papaparse';
import promiseLimit from 'promise-limit';

angular.module('logbook').directive('tagCsvUpload', ['$http', '$timeout', '$q', 'tagService', 'FileUploader', function($http, $timeout, $q, tagService, FileUploader) {
   return {
      redirect: 'E',

      scope: {
         selectedLog: '='
      },

	  template: require('./tag-csv-upload.html'),

      link: function(scope, elem, attrs) {

         scope.semaphore = promiseLimit(5);
         scope.inProcess = [];
         scope.httpCancelers = {};

         scope.clearTags = function()
         {
            scope.tagValues = [];
            scope.tagValuesByTag = {};
         };

		  scope.getTagPromise = function(chunk, isParent) {
			  return scope.semaphore(() => {
				  if (scope.cancelCheckExisting)
					  return;

				  var canceler = $q.defer();
				  scope.httpCancelers[chunk] = canceler;

				  const tagPromise = tagService.getTagValues(chunk).toPromise();

				  tagPromise
					  .then(tagValues => {
						  scope.tagValues.push(...tagValues);

						  tagValues.forEach(tagValue => {
							  scope.tagValuesByTag[tagValue.stringValue] = tagValue;
						  });

						  if (!isParent)
						  	scope.existingTagsChecked += chunk.length;
					  })
					  .finally(() => delete scope.httpCancelers[chunk]);

				  return tagPromise;
			  });
		  };

         scope.loadTags = function(stringValues, isParent)
         {
             var chunkSize = 100;
             var promises  = [];
             for(var i = 0; i < Math.ceil(stringValues.length/chunkSize); i++)
             {
                 var chunk = stringValues.slice(i*chunkSize, Math.min((i+1)*chunkSize,stringValues.length));
                 promises.push(scope.getTagPromise(chunk, isParent));
             }
             return promises;
          }

          scope.loadParents = function() {
             var parentsToLoad = Object.keys(scope.parents).filter(p => !scope.tagValuesByTag[p]);
             if( parentsToLoad.length )
                return $q.all(scope.loadTags(parentsToLoad, true));
             else {
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
             }
          };

         scope.uploader = new FileUploader({
            autoUpload: false,
            onAfterAddingFile: function(file) {
               Papa.parse(file._file, {
                  header: true,
                  transformHeader: function(header, idx) {
                     if( header )
                        header = header.trim().toLowerCase();
                     return header;
                  },
                  transform: function(value, header) {
                     if( value )
                        value = value.trim();
                     return value;
                  },
                  skipEmptyLines: true,
                  complete: function(results) {
                     delete scope.error;
                     scope.cancelCheckExisting = false;
                     scope.allLoaded = false;
                     scope.existingTagsChecked = 0;
                     $('#csvFileInput').val("");
                     var fields = results.meta.fields;
                     if( fields.indexOf('tag') < 0 
                        || fields.indexOf('tag description') < 0
                        || fields.indexOf('parents') < 0)
                     {
                        scope.error = 'File does not contain required fields.';
                        delete scope.parsedCsv;
                        scope.$digest();
                        return;
                     }
                     scope.parsedCsv = [];
                     scope.parsedCsvByTag = {};
                     scope.parents = {};
                     scope.waitingForParent = 0;
                     scope.abortUpload = false;
                     scope.numProcessed = 0;

                     results.data.forEach(function(result) {
                        if( result['tag'].length > 0
                            || result['tag description'].length > 0
                            || result['parents'].length > 0)
                        {
                           if( !result['tag description'] )
                              result['tag description'] = '';
                           if( !result['parents'] )
                              result['parents'] = '';
                           result['description'] = result['tag description'];
                           scope.parsedCsv.push(result);
                           scope.parsedCsvByTag[result['tag']] = result;
                        }
                     });
                     scope.uploader.clearQueue();
                     scope.clearTags();
                     scope.numToProcess = scope.parsedCsv.length;
                     
					 const checkExistingPromises = scope.loadTags(scope.parsedCsv.map(val => val['tag']));

                     $q.all(checkExistingPromises).then(() => {
                         if( scope.cancelCheckExisting )
                             return;
                         scope.parsedCsv.forEach(row => {
                            if( !row.status )
                               row.status = 'New';
                            var orig = scope.tagValuesByTag[row['tag']];
                            var newParents = row['parents'].split(',');
                            if( newParents.length ==1 && newParents[0] == "" )
                               newParents.splice(0,1);
                            if( newParents.length )
                               newParents.forEach(p => scope.parents[p] = true);
                            if( orig )
                            {
                               row.status = 'Update';
                               row.orig = orig;
                               var origParents = orig.parents.map(function(parent) {
                                  return parent.stringValue;
                               });
                               var parentChanged = origParents.length != newParents.length;
                               if( !parentChanged )
                               {
                                  for(var i=0; i < newParents.length; i++ )
                                     if( origParents.indexOf(newParents[i]) == -1 )
                                     {
                                        parentChanged = true;
                                        break;
                                     }
                               }

                               if(row['tag description'] == orig.description && !parentChanged )
                               {
                                  row.status = 'Unchanged';
                                  scope.numToProcess--;
                               }
}
                         });
                         scope.loadParents().then(() => scope.allLoaded = true);
                     });
                 }
               });
            }
          });
         
         scope.handleError = function(errors, row)
         {
             row.status = 'Error';
             row.error = '';
             if( errors.forEach )
                errors.forEach(function(error) {
                   row.error += error.property + ': ' + error.message;
                });
             else
                row.error = errors;
         }
         scope.removeInProcess = function(tag)
         {
             scope.inProcess = scope.inProcess.filter(val => val != tag);
         }
         scope.addTag = function(row, newParentHrefs)
         {
              return scope.semaphore(() => {
                 if( scope.abortUpload )
                    return;
                 scope.numProcessed++;
                 row.status = 'Adding...';
                 scope.inProcess.push(row['tag']);
                 return $http.post('/api/tagValues', {
                    log: scope.selectedLog._links.self.href,
                    stringValue: row['tag'],
                    description: row['tag description'],
                    parents: newParentHrefs
                 }, {
                    'noErrorPopup' : true,
                    'rawError' : true,
                    'suppressExclusiveRequest': true
                 }).then(function(result) {
                    row.status = 'Done';
                    scope.removeInProcess(row['tag']);
                 }, function(error) {
                    scope.handleError(error, row);
                    scope.removeInProcess(row['tag']);
                 });
             });
         };

         scope.updateTag = function(row, newParentHrefs)
         {
              return scope.semaphore(() => { 
                 if( scope.abortUpload )
                    return;
                 scope.numProcessed++;
                 scope.inProcess.push(row['tag']);
                 row.status = 'Updating...';
                 return $http.patch(row.orig._links.self.href, {
                    description: row['tag description'],
                    parents: newParentHrefs
                 }, {
                    'noErrorPopup' : true,
                    'rawError' : true,
                    'suppressExclusiveRequest': true
                 }).then(function(result) {
                    scope.removeInProcess(row['tag']);
                    row.status = 'Done';
                 }, function(error) {
                    scope.removeInProcess(row['tag']);
                    scope.handleError(error, row);
                 });
             });
         };

         scope.uploadAll = function(lastWaitingForParent)
         {
            scope.abortUpload = false;
               
            scope.processing = true;
            var promises = [];
            scope.waitingForParent = 0;
            scope.parsedCsv.forEach(function(row) {
               var status = row.status;
               var newParents = row['parents'].split(',');
               if( newParents.length ==1 && newParents[0] == "" )
                  newParents.splice(0,1);
               row.waitForParent = false;
               var newParentHrefs = [];
               if( status != 'Unchanged' && newParents.length > 0 )
               {
                  for( var i=0; i < newParents.length; i++ )
                     if( !scope.tagValuesByTag[newParents[i]] )
                     {
                        row.waitForParent = true;
                        scope.waitingForParent++;
                     }
                     else
                        newParentHrefs.push(scope.tagValuesByTag[newParents[i]]._links.self.href);
               }
               if( status == 'New' && !row.waitForParent )
               {
                  promises.push(scope.addTag(row, newParentHrefs));
               }
               else if( status == 'Update' && !row.waitForParent )
               {
                  promises.push(scope.updateTag(row, newParentHrefs));
               }
            });
            $q.all(promises).then(function() {
               scope.loadParents().then(function() {
                  if( scope.waitingForParent && (!lastWaitingForParent || scope.waitingForParent < lastWaitingForParent ) && !scope.abortUpload)
                     scope.uploadAll(scope.waitingForParent);
                  else
                     scope.processing = false;
               }, function() {
                  scope.processing = false;
               });
            });

         };
         scope.stopUpload = function()
         {
            var wasUploading = scope.processing;
            scope.cancelCheckExisting = true;
            scope.abortUpload = true;
            scope.processing = false;
            scope.numToProcess -= scope.numProcessed;
            scope.numProcessed = 0;
            Object.keys(scope.httpCancelers).forEach(key => scope.httpCancelers[key].resolve());
            if( !wasUploading )
            {
               scope.clearTags();
               delete scope.parsedCsv;
               delete scope.existingTagsChecked;
            }
         };

         scope.isCheckingExisting = function()
         {
            return Object.keys(scope.httpCancelers).length > 0;
         }

         scope.$on('$destroy', () => scope.stopUpload());

      }
    };
  }]);
